module.exports = __webpack_public_path__ + "static/media/1.373a93c9.jpg";